import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import { Box, Dialog, IconButton, Tooltip } from "@mui/material";
export var PhotoLightbox = function (_a) {
    var url = _a.url, onClose = _a.onClose;
    var _b = useState(1), scale = _b[0], setScale = _b[1];
    useEffect(function () {
        if (!url)
            return;
        // Сброс зума при открытии нового изображения — намеренно.
        // eslint-disable-next-line react-hooks/set-state-in-effect
        setScale(1);
    }, [url]);
    var zoomIn = function () { return setScale(function (s) { return Math.min(s + 0.3, 4); }); };
    var zoomOut = function () { return setScale(function (s) { return Math.max(s - 0.3, 0.5); }); };
    return (_jsxs(Dialog, { open: !!url, onClose: onClose, maxWidth: false, PaperProps: {
            sx: {
                background: "transparent",
                boxShadow: "none",
                overflow: "visible",
                m: 2,
            },
        }, slotProps: {
            backdrop: { sx: { bgcolor: "rgba(0,0,0,0.92)" } },
        }, children: [_jsxs(Box, { sx: {
                    position: "fixed",
                    top: 16,
                    right: 16,
                    zIndex: 1400,
                    display: "flex",
                    gap: 1,
                }, children: [_jsx(Tooltip, { title: "Zoom in", children: _jsx(IconButton, { onClick: zoomIn, size: "small", sx: { bgcolor: "rgba(255,255,255,0.1)", "&:hover": { bgcolor: "rgba(255,255,255,0.2)" } }, children: _jsx(ZoomInIcon, { sx: { color: "#fff", fontSize: 20 } }) }) }), _jsx(Tooltip, { title: "Zoom out", children: _jsx(IconButton, { onClick: zoomOut, size: "small", sx: { bgcolor: "rgba(255,255,255,0.1)", "&:hover": { bgcolor: "rgba(255,255,255,0.2)" } }, children: _jsx(ZoomOutIcon, { sx: { color: "#fff", fontSize: 20 } }) }) }), _jsx(Tooltip, { title: "Close", children: _jsx(IconButton, { onClick: onClose, size: "small", sx: { bgcolor: "rgba(255,255,255,0.1)", "&:hover": { bgcolor: "rgba(255,255,255,0.2)" } }, children: _jsx(CloseIcon, { sx: { color: "#fff", fontSize: 20 } }) }) })] }), url && (_jsx(Box, { sx: {
                    maxWidth: "90vw",
                    maxHeight: "90vh",
                    overflow: "auto",
                    borderRadius: "12px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }, onClick: function (e) { return e.target === e.currentTarget && onClose(); }, children: _jsx("img", { src: url, alt: "document", style: {
                        transform: "scale(".concat(scale, ")"),
                        transformOrigin: "center center",
                        transition: "transform 200ms ease",
                        maxWidth: scale <= 1 ? "85vw" : "none",
                        maxHeight: scale <= 1 ? "85vh" : "none",
                        display: "block",
                        borderRadius: 8,
                        userSelect: "none",
                    }, draggable: false }) }))] }));
};
